import enquireJs from 'enquire.js'

export const DeviceTypes = {
  DESKTOP: 'desktop',
  TABLET: 'tablet',
  MOBILE: 'mobile'
} as const
export type DeviceTypes = typeof DeviceTypes
export type DeviceTypeKeys = keyof DeviceTypes
export type DeviceType = DeviceTypes[DeviceTypeKeys]

type CallbackFunc = (device: DeviceType) => void

export const deviceEnquire = function (callback: CallbackFunc) {
  const matchDesktop = {
    match: () => {
      callback && callback(DeviceTypes.DESKTOP)
    }
  }

  const matchLablet = {
    match: () => {
      callback && callback(DeviceTypes.TABLET)
    }
  }

  const matchMobile = {
    match: () => {
      callback && callback(DeviceTypes.MOBILE)
    }
  }

  // screen and (max-width: 1087.99px)
  enquireJs
    .register('screen and (max-width: 576px)', matchMobile)
    .register(
      'screen and (min-width: 576px) and (max-width: 1199px)',
      matchLablet
    )
    .register('screen and (min-width: 1200px)', matchDesktop)
}

/**
 * Simple mobile device detection using user agent
 * Useful for initial/fallback detection
 */
export const isMobileDevice = (): boolean => {
  if (typeof navigator === 'undefined') return false

  const userAgent =
    navigator.userAgent || navigator.vendor || (window as any).opera

  // Check for common mobile user agents
  return /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(
    userAgent.toLowerCase()
  )
}
